import { Component, OnInit } from '@angular/core';
import { LandingServiceService } from 'src/app/Services/landing-service.service';
import * as myGlobals from "../../../app.component";
import { ViewVideoComponent } from './view-video/view-video.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-video-gallery',
  templateUrl: './video-gallery.component.html',
  styleUrls: ['./video-gallery.component.scss']
})
export class VideoGalleryComponent implements OnInit {

  public baseUrl = myGlobals.baseFileUrl;

  videoGallery: any = [];

  startTime: any;
  currentVideoTime: any;

  playerVars: {
    autoplay: 0,
    modestbranding: 0,
    controls: 0,
    disablekb: 0,
    rel: 0,
    showinfo: 0,
    fs: 0,
    playsinline: 0,
  }

  constructor(
    private landingService: LandingServiceService,
    public dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.baseUrl = this.baseUrl + "/homepage/video_gallery";
    this.landingService.getVideoGallery().subscribe(data=>this.setVideoGallery(data));
  }

  setVideoGallery(data) {
    // console.log(data);
    this.videoGallery = data['Galleries'];
    // console.log(this.videoGallery);
  }
  viewVideoGallery(row){
    const dialogRef = this.dialog.open(ViewVideoComponent, {
      data: { row }, height: '80%', width: '50%'
    });
    dialogRef.afterClosed().subscribe(() => { });
  }

}
